import { useLocalSearchParams, useRouter } from 'expo-router';
import { useEffect } from 'react';
import useLayoutReady from 'shared/hooks/useLayoutReady/useLayoutReady';

const useGetFlowStepId = () => {
  const router = useRouter();
  const { id } = useLocalSearchParams<{ id: string }>();

  const isLayoutReady = useLayoutReady();

  useEffect(() => {
    if (isLayoutReady && !id) {
      router.replace('/onboarding');
    }
  }, [id, isLayoutReady, router]);

  return id;
};

export default useGetFlowStepId;
